import { PROFILE } from 'store/actions/types'
import Api from 'common/Api'
import EventEmitter from 'common/EventEmitter'
import { Events } from 'common/Enums'

export const getProfile = (payload) => {
    return (dispatch) => {
        dispatch({
            type: PROFILE.GET_PROFILE,
            payload
        })

        return Api.getUserInfo()
            .then((response) => {
                dispatch(getProfileSuccess(response.data))
            })
            .catch((error) => {
                dispatch(getProfileFail(error))
            })
    }
}

export const getProfileSuccess = (payload) => (dispatch) => {
    EventEmitter.emit(Events.Profile, payload)

    dispatch({
        type: PROFILE.GET_PROFILE_SUCCESS,
        payload: payload
    })
}

export const getProfileFail = (payload) => ({
    type: PROFILE.GET_PROFILE_FAIL,
    payload
})

export const sendResetLink = (payload) => (dispatch) => {
    dispatch({
        type: PROFILE.SEND_RESET_LINK,
        payload
    })
    return Api.sendResetLink(payload.values)
        .then((response) => {
            const data = response?.data || {}
            dispatch({
                type: PROFILE.SEND_RESET_LINK_SUCCESS,
                payload: data
            })
        })
        .catch((error) => {
            dispatch({
                type: PROFILE.SEND_RESET_LINK_FAIL,
                payload: error.response.data
            })
        })
}

export const resetPassword = (payload) => (dispatch) => {
    dispatch({
        type: PROFILE.RESET_PASSWORD,
        payload
    })

    return Api.resetPassword(payload.values)
        .then((response) => {
            const data = response?.data || {}
            dispatch({
                type: PROFILE.RESET_PASSWORD_SUCCESS,
                payload: data
            })
        })
        .catch((error) => {
            dispatch({
                type: PROFILE.RESET_PASSWORD_FAIL,
                payload: error.response.data
            })
        })
}

export const putProfile = (payload) => (dispatch) => {
    dispatch({
        type: PROFILE.PUT_PROFILE,
        payload
    })
    return Api.updateProfile(payload.values)
        .then((response) => {
            const data = response?.data || {}
            dispatch({
                type: PROFILE.PUT_PROFILE_SUCCESS,
                payload: data
            })
            dispatch(getProfile())
        })
        .catch((error) => {
            dispatch({
                type: PROFILE.PUT_PROFILE_FAIL,
                payload: error.response.data
            })
        })
}

export const changePassword = (payload) => (dispatch) => {
    dispatch({
        type: PROFILE.PUT_PROFILE,
        payload
    })
    return Api.changePassword(payload.values)
        .then((response) => {
            const data = response?.data || {}
            dispatch({
                type: PROFILE.PUT_PROFILE_SUCCESS,
                payload: data
            })
        })
        .catch((error) => {
            dispatch({
                type: PROFILE.PUT_PROFILE_FAIL,
                payload: error.response.data
            })
        })
}

export const setDid = (payload) => {
    return (dispatch) => {
        dispatch({
            type: PROFILE.SET_DID,
            payload
        })

        return Api.updateDid(payload.destination_number)
            .then((response) => {
                if (!response.data.success) dispatch(setDidFail(response.data.message, payload.prevValue))
            })
            .catch(() => {
                dispatch(setDidFail('DID number change had failed', payload.prevValue))
            })
    }
}

export const setDidFail = (message, prevValue) => ({
    type: PROFILE.SET_DID_FAIL,
    payload: { message, prevValue }
})

export const clearDidsError = () => ({
    type: PROFILE.CLEAR_ALERT
})
